import { type PropsWithChildren } from "react";

import { ScrollbarScript, ToastProvider, Tooltip, TopLoadingBar } from "./components";

export const LighthouseProvider = ({ children }: PropsWithChildren) => {
  return (
    <>
      <ScrollbarScript />
      <ToastProvider>
        <Tooltip.Provider delayDuration={100}>
          <TopLoadingBar />
          {children}
        </Tooltip.Provider>
      </ToastProvider>
    </>
  );
};

export default LighthouseProvider;
